<template>
  <el-form :model="form" ref="form" label-position="top">
    <el-row>
      <el-col :span="12">
        <el-form-item label="最大消息长度" prop="maxmsglength">
          <el-input-number v-model="form.maxmsglength"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="最大深度" prop="maxdepth">
          <el-input-number v-model="form.maxdepth"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="阈值" prop="threshold">
          <el-input-number v-model="form.threshold"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否自动创建队列" prop="autocreate">
          <el-switch
            v-model="form.autocreate"
            active-text="开"
            inactive-text="关">
          </el-switch>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
  import rApi from "@/api/senior/seniorconf";
let datafault = {
};
export default {
  components: { rApi },
  props: {
    uuid:""
  },
  data() {
    return {
      form:{
        maxmsglength:104857600,
        maxdepth:999999999,
        threshold:50000,
        autocreate:true
      }
    };
  },
  mounted() {
    if(this.uuid){
      rApi.getCsSenior(this.uuid).then(resp=>{
        var _form = JSON.parse(resp.data);
        this.form.maxmsglength = _form.maxmsglength?_form.maxmsglength:this.form.maxmsglength;
        this.form.maxdepth = _form.maxdepth?_form.maxdepth:this.form.maxdepth;
        this.form.threshold = _form.threshold?_form.threshold:this.form.threshold;
        this.form.autocreate = _form.autocreate||_form.autocreate===false?_form.autocreate:this.form.autocreate;
      });
    }
  },
  methods: {
    save(){
      if(this.uuid){
        rApi.doSaveForCsSenior(this.uuid,JSON.stringify(this.form)).then(()=>this.$message.success("操作成功！"));
      }
      return this.form;
    }
  }
};
</script>
<style scoped>
</style>